import { DefaultTheme } from 'styled-components';

export const defaultTheme: DefaultTheme = {
  fonts: {
    primary: 'Gloriola Std',
    secondary: 'Space Grotesk',
  },
  breakpoints: {
    xs: '460px',
    sm: '768px',
    md: '1100px',
    lg: '1366px',
    xl: '1920px',
  },
  fontSize: 16,
  lineHeight: 16,

  colors: {
    background: '#F5F5F5',
    shape: '#FFFFFF',

    title: '#000000',
    text: '#515151',
    textLight: '#878787',
    line: '#C4C4C4',

    main: '#626CC3',
    mainDark: '#364372',

    success: '#0DAB01',
    error: '#DE1616',
    warning: '#FF9700',
    partial: '#78a630',
  },

  weights: {
    heavy: 700,
    standard: 500,
    light: 400,
  },
};
